import { useState } from 'react';
import { Loader, Dimmer, Form } from 'semantic-ui-react';

import { useAuthContext } from '../../../contexts/AuthContext';
import FHIRUpdater from '../../../data/FHIRUpdater';
import { FlagBuilder } from '../../../fhir-sdoh';

import type { NewFlagProps } from './types';


function NewFlag(props: NewFlagProps) {
  const authInfo = useAuthContext();
  const practitionerId = authInfo.practitionerId;
  const practitionerName = authInfo.practitionerName;
  const [dimmerProcess, setDimmerProcess] = useState(false);
  const [flag, setFlag] = useState({
    text: '',
    code: 'INFO',
    display: 'Info',
  });

  const flagTypes = [
    { code: 'INFO', display: 'Info' },
    { code: 'WARNING', display: 'Warning' },
    { code: 'REDFLAG', display: 'RedFlag' },
  ];

  const createFlag = () => {
    if (flag.text !== '') {
      setDimmerProcess(true);

      const flagPayload = FlagBuilder.build(
        // `patientId` originates as `fhirPatient.id`, which FHIR leaves `0..1`,
        // and is optional the whole way down; `FlagBuilder.build` requires a
        // `string`. Asserted rather than guarded — an absent id currently builds
        // a Flag whose subject reference is `Patient/undefined` and POSTs it,
        // and refusing to build would change that.
        props.patientId as string,
        practitionerId,
        // {"active"},
        { code: 'admin', display: 'Administrative' }, //http://terminology.hl7.org/CodeSystem/flag-category //Always Admin //TODO..Update Flag Builder
        { code: flag.code, display: flag.display }, //custom: projectWell: https://www.hl7.org/fhir/valueset-flag-code.html (redflag, warning etc)
        flag.text,
        practitionerName,
        // Same shape as `patientId` above: optional the whole way from
        // `flatpatient.org`, required by the builder.
        props.org as string
      );

      FHIRUpdater('/Flag/' + flagPayload.id, authInfo.token, flagPayload).then(
        (_response) => {
          // `!` rather than `?.` on both: `FlagsList` always supplies these, and
          // an absent one throws today. Asserting preserves that; chaining would
          // emit a guard and silently skip the refetch and the close.
          props.refreshFlags!();
          setDimmerProcess(false);
          props.setOpen!(false);
          setFlag({ text: '', code: 'INFO', display: 'Info' });
        },
        (_error) => {
          setDimmerProcess(false);
        }
      );
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, name: string) => {
    const { value } = e.target;

    setFlag((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleTypeChange = (code: string, display: string) => {
    setFlag((prevState) => ({
      ...prevState,
      code: code,
      display: display,
    }));
  };

  return (
    <div>
      <Dimmer active={dimmerProcess} inverted>
        <Loader />
      </Dimmer>
      <Form onSubmit={createFlag} autoComplete="off" error>
        <Form.Group>
          <Form.Input maxLength="40" name="text" value={flag.text} onChange={(e) => handleChange(e, 'text')} />
          <Form.Group inline>
            {flagTypes.map((type, index) => (
              <Form.Radio
                key={index}
                label={type.display}
                value={type.code}
                checked={flag.code === type.code}
                onChange={(_e) => handleTypeChange(type.code, type.display)}
              />
            ))}
          </Form.Group>
          <Form.Button primary content="Add" />
        </Form.Group>
      </Form>
    </div>
  );
}

export default NewFlag;
